import { render, staticRenderFns } from "./PoliciesModal.vue?vue&type=template&id=005f67ed&scoped=true"
import script from "./PoliciesModal.vue?vue&type=script&lang=js"
export * from "./PoliciesModal.vue?vue&type=script&lang=js"
import style0 from "./PoliciesModal.vue?vue&type=style&index=0&id=005f67ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.94.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005f67ed",
  null
  
)

export default component.exports